import { render, staticRenderFns } from "./BioTestingButtons.vue?vue&type=template&id=68baeed8&scoped=true"
import script from "./BioTestingButtons.vue?vue&type=script&lang=js"
export * from "./BioTestingButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68baeed8",
  null
  
)

export default component.exports